import React, { FC, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { MonitorsUnitType } from '../../QueuePanel/QueuePanel';
import { TicketStatus } from '../../../../types/enums';
import classes from './ModalQueueNewTicket.module.scss';
import classNames from 'classnames';
import { QueueArrowIcon } from '../../../../assets/svgComponents/QueueArrowIcon';
import { isQueueScreenDarkTheme } from '../../../../constants/API';

type ModalQueueNewTicketProps = {
  tickets: MonitorsUnitType;
};

const ModalQueueNewTicket: FC<ModalQueueNewTicketProps> = ({ tickets }) => {
  const callingTickets = useMemo(
    () =>
      (tickets.items || [])
        .filter((e) => e && e.status !== TicketStatus.TakeInWorking)
        .slice(0, 4),
    [tickets.items]
  );

  if (callingTickets.length === 0 || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className={classNames(classes.modalOverlay, {
        [classes.darkThemeModalOverlay]: isQueueScreenDarkTheme
      })}
    >
      <div
        className={classNames(classes.modalContainer, {
          [classes.darkModalContainer]: isQueueScreenDarkTheme
        })}
      >
        <div className={classes.ticketsListContainer}>
          {callingTickets.map((e) => (
            <div className={classes.ticketWrapper} key={e.itemId}>
              <div className={classNames(classes.ticketAlign, classes.ticketName)}>
                <span>{e.itemName}</span>
              </div>

              <div className={classes.arrowIconWrapper}>
                <QueueArrowIcon />
              </div>

              <div
                className={classNames(classes.ticketAlign, classes.ticketWindow, {
                  [classes.darkThemeText]: isQueueScreenDarkTheme
                })}
              >
                <span>{e.window}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ModalQueueNewTicket;
